import { Box, Flex, Text, Image, Alert, Link } from '@chakra-ui/react'
import LabCorpLogo from 'assets/images/LabCorpLogo.png'
import { useHistory } from 'react-router-dom'
import { ChakraPrimaryButton } from 'components/Button'
import { useLabSchedulingContext } from 'context/LabSchedulingContext/LabSchedulingProvider'
import { RoutePaths } from 'containers/Core/Routes'
import imageSrc from 'assets/images/check-yellow.svg'
import alertUrl from 'assets/images/alert-info.svg'
import QRCode from 'react-qr-code'
import { formatDateTime } from 'utils/time.utils'

const LabConfirmation = () => {
  const {
    selectedLab,
    labAppointmentState,
    labState,
  } = useLabSchedulingContext()
  const history = useHistory()
  const {
    selectedLabAddress,
    selectedDate,
    selectedTime,
    labTimezone,
  } = labState
  const { qrCode } = labAppointmentState

  const dateTime = `${selectedDate}T${selectedTime}`

  const formattedDate = formatDateTime(dateTime, labTimezone)

  const clickHandler = () => {
    history.push(`${RoutePaths.DASHBOARD}?from=labScheduling`)
  }

  return (
    <Box bg="white" p={8} borderRadius="lg" boxShadow="lg" width="sm">
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Image src={imageSrc} marginBottom="1rem" />
        <Text fontFamily="Instrument Serif" fontSize="1.5rem">
          Appointment confirmed!
        </Text>
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          width="100%"
          marginBottom="2rem"
        >
          <Text fontWeight="500" color="#161E35" marginBottom=".5rem">
            Lab Location
          </Text>
          <Text margin="0">{selectedLabAddress}</Text>
        </Flex>

        <Flex
          flexDirection="column"
          alignItems="flex-start"
          width="100%"
          marginBottom="2rem"
        >
          <Text fontWeight="500" color="#161E35" marginBottom=".5rem">
            Date and time
          </Text>
          <Text margin="0">{formattedDate}</Text>
        </Flex>

        <Flex
          flexDirection="column"
          alignItems="flex-start"
          width="100%"
          marginBottom="2rem"
        >
          <Text fontWeight="500" color="#161E35" marginBottom=".5rem">
            Check-in details
          </Text>
          <Text margin="0">
            When you arrive, you can scan this QR code at the Express table to
            quickly check-in.
          </Text>
        </Flex>
        <Box marginBottom="1.5rem">
          <QRCode value={qrCode} size={120} />
        </Box>
        <ChakraPrimaryButton width="100%" onClick={() => clickHandler()}>
          Go to Dashboard
        </ChakraPrimaryButton>
        <Alert backgroundColor="#E8EFF9" marginTop="1.5rem">
          <Image src={alertUrl} marginRight=".675rem" />
          <Text
            margin="0"
            fontSize=".75rem"
            color="#23253D"
            fontWeight="400"
            lineHeight="normal"
          >
            If you have any questions ahead of your appointment, we&apos;re here
            to support you! Please refer to{' '}
            <Link
              href="https://allarapatients.tawk.help/"
              textDecoration="underline"
            >
              this FAQ
            </Link>
            .
          </Text>
        </Alert>
        {selectedLab === 'LabCorp' && (
          <Image src={LabCorpLogo} width="90px" marginTop="2.5rem" />
        )}
      </Flex>
    </Box>
  )
}

export default LabConfirmation
